var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4165 0C0.186602 0 0 0.185306 0 0.413912V23.5864V23.5861C0 23.8147 0.186594 24 0.4165 24H34.5835C34.8134 24 35 23.8147 35 23.5861V0.413624V0.413912C35 0.185306 34.8134 0 34.5835 0H0.4165ZM1.48437 0.827514H33.5159L17.5002 15.5689L1.48437 0.827514ZM0.833319 1.35775L11.9272 11.56L0.833319 22.5773V1.35775ZM34.167 1.35775V22.578L23.0731 11.5607L34.167 1.35775ZM12.5388 12.129L17.2132 16.4348V16.4351C17.374 16.5861 17.6257 16.5861 17.7864 16.4351L22.4608 12.1292L33.5807 23.1724H1.41897L12.5389 12.1292L12.5388 12.129Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.b12194970ff0b0a9103fe93571fdf040.svg";
export { ForwardRef as ReactComponent };